import { render, staticRenderFns } from "./MoveLobby.vue?vue&type=template&id=20727292&scoped=true&"
import script from "./MoveLobby.vue?vue&type=script&lang=js&"
export * from "./MoveLobby.vue?vue&type=script&lang=js&"
import style0 from "./MoveLobby.vue?vue&type=style&index=0&id=20727292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20727292",
  null
  
)

export default component.exports